<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
  <p>
    <img src="assets/home/cada_orgsetup.png" style="width:100%;">
  </p>
<!-- </div> -->